import { render, staticRenderFns } from "./release_channel_ref_edit.vue?vue&type=template&id=1b18a53d&scoped=true"
import script from "./release_channel_ref_edit.vue?vue&type=script&lang=js"
export * from "./release_channel_ref_edit.vue?vue&type=script&lang=js"
import style0 from "./release_channel_ref_edit.vue?vue&type=style&index=0&id=1b18a53d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b18a53d",
  null
  
)

export default component.exports